import React, { useState, useRef, useEffect } from 'react';

const TestCards = () => {
  const [tests, setTests] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [errorMssg, setErrorMssg] = useState(null);
  const scrollRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState('');
  const [selectedTitle, setSelectedTitle] = useState('');

  useEffect(() => {
    const fetchTests = async () => {
      try {
        const response = await fetch('/api/ViewFrontPackageForm', {
          method: 'POST',
        });

        if (response.ok) {
          const data = await response.json();
          setTests(data);
        } else {
          setErrorMssg('Failed to fetch test packages.');
        }
      } catch (error) {
        console.error('Error fetching tests:', error);
        setErrorMssg('Error fetching test packages.');
      }
    };

    fetchTests();
  }, []);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const scroll = (direction) => {
    const scrollAmount = 300;
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  const handleWhatsAppClick = (testName) => {
    const phoneNumber = "9115223372";
    const message = `Hi, I'm interested in booking a ${testName}. Could you please provide more details?`;
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const nextCard = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % tests.length);
  };

  const prevCard = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + tests.length) % tests.length);
  };

  const goToCard = (index) => {
    setCurrentIndex(index);
  };

  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const minSwipeDistance = 50;

  const onTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;

    if (isLeftSwipe) nextCard();
    if (isRightSwipe) prevCard();
  };

  if (tests.length === 0 && !errorMssg) {
    return <div className="text-center py-5">Loading tests...</div>;
  }

  if (errorMssg) {
    return <div className="text-danger text-center py-5">{errorMssg}</div>;
  }

  const openModal = (title, description) => {
    setSelectedTitle(title);
    setSelectedDescription(description);
    setShowModal(true);
  };

  const renderModal = () => (
    <>
      <div className="modal fade show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
          <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '16px', overflow: 'hidden' }}>
            <div
              className="modal-header border-0 text-white position-relative"
              style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                padding: '24px 32px'
              }}
            >
              <div>
                <h5 className="modal-title fw-bold mb-1" style={{ fontSize: '1.5rem' }}>{selectedTitle}</h5>
                <p className="mb-0 opacity-90" style={{ fontSize: '0.95rem' }}>Test Parameters Included</p>
              </div>
              <button
                type="button"
                className="btn-close btn-close-white position-absolute"
                onClick={() => setShowModal(false)}
                style={{ top: '24px', right: '24px' }}
              ></button>
            </div>
            <div className="modal-body p-0">
              <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                <table className="table table-hover mb-0">
                  <thead style={{ position: 'sticky', top: 0, zIndex: 10, background: '#f8f9fa' }}>
                  </thead>
                  <tbody>
                    {selectedDescription.split(',').map((param, index) => (
                      <tr key={index} style={{ transition: 'background-color 0.2s' }}>
                        <td className="px-4 py-3 text-center" style={{ fontSize: '0.9rem', color: '#667eea', fontWeight: 600 }}>
                          {index + 1}
                        </td>
                        <td className="px-4 py-3" style={{ fontSize: '0.95rem', color: '#2d3748' }}>
                          {param.trim()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="border-top p-3 text-center" style={{ background: '#f8f9fa' }}>
                <small className="text-muted">Total Parameters: <strong>{selectedDescription.split(',').length}</strong></small>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal-backdrop fade show" style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}></div>
    </>
  );

  if (isMobile) {
    return (
      <div style={{ background: 'linear-gradient(to bottom, #f7fafc 0%, #edf2f7 100%)', minHeight: '100vh' }} className="py-3">
        <div className="row align-items-center ms-1 me-1">
          <h1 className="text-center mb-3" style={{ fontWeight: "600", letterSpacing: "2px" }}>
            About Us
          </h1>
          <div className="col-md-7">
            <p className="lead">
              At <strong>KLV Diagnostic Center</strong>, we are dedicated to pushing the boundaries of
              science and innovation. Our state-of-the-art facilities and expert team work tirelessly to
              provide accurate and reliable results across a wide range of scientific disciplines.
            </p>
            <p>
              Established in 2018, our lab has been a trusted partner for researchers, healthcare
              professionals, and industries. We adhere to the highest standards of quality and
              precision, ensuring that our clients receive data they can depend on.
            </p>
            <p>
              Our commitment to continuous improvement and innovation drives us to stay ahead in the
              rapidly evolving field of laboratory sciences.
            </p>
          </div>
          <div className="col-md-5 mb-4 mb-md-0">
            <img
              src="https://www.sunstar.com/media_18e9dcd7276d4163ffe2096dc5533439f1879f828.jpeg?width=750&format=jpeg&optimize=medium"
              alt="Laboratory"
              className="img-fluid rounded shadow"
            />
          </div>
        </div>
        <div className="container">
          <div className="row justify-content-center mb-4">
            <div className="col-12 col-sm-8 col-md-6">
              <div
                className="card border-0 shadow-lg"
                style={{
                  maxWidth: '360px',
                  margin: '0 auto',
                  borderRadius: '20px',
                  overflow: 'hidden',
                  transition: 'transform 0.3s ease'
                }}
                onTouchStart={onTouchStart}
                onTouchMove={onTouchMove}
                onTouchEnd={onTouchEnd}
              >
                <div
                  className="card-header border-0 text-white"
                  style={{
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    padding: '20px 24px'
                  }}
                >
                  <h5 className="mb-0 fw-bold" style={{ fontSize: '1.25rem' }}>
                    {tests[currentIndex].name}
                  </h5>
                </div>

                <div className="card-body" style={{ padding: '20px' }}>
                  <div className="d-flex align-items-center mb-3 p-2 rounded" style={{ background: '#f7fafc' }}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ marginRight: '10px' }}>
                      <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15" stroke="#667eea" strokeWidth="2" />
                      <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="#667eea" strokeWidth="2" />
                    </svg>
                    <div>
                      <p className="mb-0 text-muted" style={{ fontSize: '0.75rem', fontWeight: 500 }}>Total Parameters</p>
                      <p className="mb-0 fw-bold" style={{ fontSize: '1rem', color: '#667eea' }}>{tests[currentIndex].totalParameter}</p>
                    </div>
                  </div>

                  <button
                    className="btn btn-outline-primary mb-3 px-3 py-2"
                    onClick={() =>
                      openModal(tests[currentIndex].name, tests[currentIndex].description)
                    }
                    style={{
                      borderRadius: '10px',
                      borderWidth: '2px',
                      fontWeight: 600,
                      fontSize: '0.85rem',
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ marginRight: '6px', display: 'inline' }}>
                      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                      <path d="M12 16V12M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    View All Parameters
                  </button>

                  <div className="mb-2">
                    <div className="d-flex align-items-center justify-content-between p-2 rounded" style={{ background: 'linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)' }}>
                      <div className="d-flex align-items-center gap-2">
                        <span className="text-danger text-decoration-line-through" style={{ fontSize: '0.9rem', fontWeight: 600 }}>
                          ₹{tests[currentIndex].mrp}
                        </span>
                      </div>
                      <span className="fw-bold" style={{ fontSize: '1.3rem', color: '#0284c7' }}>
                        ₹{tests[currentIndex].rate}
                      </span>
                    </div>
                  </div>

                  <button
                    className="btn btn-success w-100 py-2 d-flex align-items-center justify-content-center"
                    onClick={() => handleWhatsAppClick(tests[currentIndex].name)}
                    style={{
                      backgroundColor: '#25D366',
                      borderColor: '#25D366',
                      borderRadius: '10px',
                      fontSize: '0.9rem',
                      fontWeight: 600,
                      transition: 'all 0.3s ease'
                    }}
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="white" style={{ marginRight: '6px' }}>
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                    </svg>
                    Book via WhatsApp
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center align-items-center gap-3 mb-4">
            <button
              className="btn btn-primary d-flex align-items-center px-4 py-2"
              onClick={prevCard}
              style={{ borderRadius: '10px', fontWeight: 600 }}
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ marginRight: '6px' }}>
                <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              Previous
            </button>
            <span className="badge px-3 py-2" style={{ background: '#667eea', fontSize: '0.9rem' }}>
              {currentIndex + 1} of {tests.length}
            </span>
            <button
              className="btn btn-primary d-flex align-items-center px-4 py-2"
              onClick={nextCard}
              style={{ borderRadius: '10px', fontWeight: 600 }}
            >
              Next
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ marginLeft: '6px' }}>
                <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          </div>

          <div className="d-flex justify-content-center gap-2">
            {tests.map((_, index) => (
              <button
                key={index}
                className="rounded-circle border-0"
                onClick={() => goToCard(index)}
                style={{
                  width: '10px',
                  height: '10px',
                  padding: '0',
                  background: index === currentIndex ? '#667eea' : '#cbd5e0',
                  transition: 'all 0.3s ease',
                  transform: index === currentIndex ? 'scale(1.3)' : 'scale(1)'
                }}
              ></button>
            ))}
          </div>
        </div>
        <div className="container my-5">
          <h1 className="text-center mb-5 fw-bold" style={{ letterSpacing: "2px", color: "#00060dff" }}>
            Our Laboratory Features
          </h1>

          <div className="row gy-4">
            {/* Feature 1 */}
            <div className="col-md-4 text-center">
              <div className="p-4 border rounded shadow-sm h-100">
                <div className="mb-3 text-primary" style={{ fontSize: "3rem" }}>
                    <i className="bi bi-wrench"></i>
                </div>
                <h4 className="mb-3">Advanced Equipment</h4>
                <p>
                  Our laboratory is equipped with state-of-the-art instruments ensuring accurate and reliable results.
                </p>
              </div>
            </div>

            {/* Feature 2 */}
            <div className="col-md-4 text-center">
              <div className="p-4 border rounded shadow-sm h-100">
                <div className="mb-3 text-primary" style={{ fontSize: "3rem" }}>
                  <i className="bi bi-person-check-fill"></i>
                </div>
                <h4 className="mb-3">Expert Staff</h4>
                <p>
                  Skilled scientists and technicians with years of experience guarantee high-quality analysis and service.
                </p>
              </div>
            </div>

            {/* Feature 3 */}
            <div className="col-md-4 text-center">
              <div className="p-4 border rounded shadow-sm h-100">
                <div className="mb-3 text-primary" style={{ fontSize: "3rem" }}>
                  <i className="bi bi-shield-check"></i>
                </div>
                <h4 className="mb-3">Quality Assurance</h4>
                <p>
                  Rigorous quality control protocols ensure compliance with international standards and certifications.
                </p>
              </div>
            </div>

            {/* Feature 4 */}
            <div className="col-md-4 text-center">
              <div className="p-4 border rounded shadow-sm h-100">
                <div className="mb-3 text-primary" style={{ fontSize: "3rem" }}>
                  <i className="bi bi-clock-history"></i>
                </div>
                <h4 className="mb-3">Timely Reporting</h4>
                <p>
                  We prioritize fast turnaround times without compromising accuracy to support your critical decision-making.
                </p>
              </div>
            </div>

            {/* Feature 5 */}
            <div className="col-md-4 text-center">
              <div className="p-4 border rounded shadow-sm h-100">
                <div className="mb-3 text-primary" style={{ fontSize: "3rem" }}>
                  <i className="bi bi-people"></i>
                </div>
                <h4 className="mb-3">Collaborative Approach</h4>
                <p>
                  We work closely with researchers and clients to tailor solutions and foster scientific innovation.
                </p>
              </div>
            </div>

            {/* Feature 6 */}
            <div className="col-md-4 text-center">
              <div className="p-4 border rounded shadow-sm h-100">
                <div className="mb-3 text-primary" style={{ fontSize: "3rem" }}>
                  <i className="bi bi-graph-up-arrow"></i>
                </div>
                <h4 className="mb-3">Innovative Research</h4>
                <p>
                  Our commitment to continuous improvement drives pioneering studies and breakthrough discoveries.
                </p>
              </div>
            </div>
          </div>
        </div>

        {showModal && renderModal()}
      </div>
    );
  }

  return (

    <div style={{ background: 'linear-gradient(to bottom, #f7fafc 0%, #edf2f7 100%)', minHeight: '100vh' }} className="">
      <div className="container my-5">
        <div className="row align-items-center">
          <h1 className="text-center mb-3" style={{ fontWeight: "600", letterSpacing: "2px" }}>
            About Us
          </h1>
          <div className="col-md-5 mb-4 mb-md-0">
            <img
              src="https://www.sunstar.com/media_18e9dcd7276d4163ffe2096dc5533439f1879f828.jpeg?width=750&format=jpeg&optimize=medium"
              alt="Laboratory"
              className="img-fluid rounded shadow"
            />
          </div>

          <div className="col-md-7">
            <h2 className="mb-3">About Our Laboratory</h2>
            <p className="lead">
              At <strong>KLV Diagnostic Center</strong>, we are dedicated to pushing the boundaries of
              science and innovation. Our state-of-the-art facilities and expert team work tirelessly to
              provide accurate and reliable results across a wide range of scientific disciplines.
            </p>
            <p>
              Established in 2005, our lab has been a trusted partner for researchers, healthcare
              professionals, and industries. We adhere to the highest standards of quality and
              precision, ensuring that our clients receive data they can depend on.
            </p>
            <p>
              Our commitment to continuous improvement and innovation drives us to stay ahead in the
              rapidly evolving field of laboratory sciences.
            </p>
          </div>
        </div>
      </div>
      <div className="container">
        <div
          ref={scrollRef}
          className="d-flex overflow-auto gap-4 py-2 w-100 mb-4"
          style={{ scrollBehavior: 'smooth', scrollbarWidth: 'thin' }}
        >
          {tests.map((test, index) => (
            <div
              key={index}
              className="card border-0 shadow-lg flex-shrink-0"
              style={{
                minWidth: '340px',
                maxWidth: '340px',
                borderRadius: '20px',
                overflow: 'hidden',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-8px)';
                e.currentTarget.style.boxShadow = '0 20px 40px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '';
              }}
            >
              <div
                className="card-header border-0 text-white"
                style={{
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                  padding: '20px 24px'
                }}
              >
                <h5 className="mb-0 fw-bold" style={{ fontSize: '1.25rem' }}>
                  {test.name}
                </h5>
              </div>

              <div className="card-body d-flex flex-column" style={{ padding: '20px' }}>
                <div className="d-flex align-items-center mb-3 p-2 rounded" style={{ background: '#f7fafc' }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" style={{ marginRight: '10px', flexShrink: 0 }}>
                    <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15" stroke="#667eea" strokeWidth="2" />
                    <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke="#667eea" strokeWidth="2" />
                  </svg>
                  <div>
                    <p className="mb-0 text-muted" style={{ fontSize: '0.75rem', fontWeight: 500 }}>Total Parameters</p>
                    <p className="mb-0 fw-bold" style={{ fontSize: '1rem', color: '#667eea' }}>{test.totalParameter}</p>
                  </div>
                </div>

                <button
                  className="btn btn-outline-primary mb-3 px-3 py-2"
                  onClick={() => openModal(test.name, test.description)}
                  style={{
                    borderRadius: '10px',
                    borderWidth: '2px',
                    fontWeight: 600,
                    fontSize: '0.85rem',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" style={{ marginRight: '6px', display: 'inline' }}>
                    <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" />
                    <path d="M12 16V12M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                  View All Parameters
                </button>

                <div className="mb-2">
                  <div className="p-2 rounded" style={{ background: 'linear-gradient(135deg, #e0f2fe 0%, #dbeafe 100%)' }}>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <strong>MRP</strong>
                      <span className="text-danger text-decoration-line-through" style={{ fontSize: '0.9rem', fontWeight: 600 }}>
                        ₹{test.mrp}
                      </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <strong>Rate</strong>
                      <span className="fw-bold" style={{ fontSize: '1.3rem', color: '#0284c7' }}>
                        ₹{test.rate}
                      </span>
                    </div>
                  </div>
                </div>
                <span className="badge px-2 py-1" style={{ background: '#dcfce7', color: '#16a34a', fontSize: '0.7rem', fontWeight: 600 }}>
                  Save ₹{test.mrp - test.rate}
                </span>

                <button
                  className="btn btn-success w-100 py-2 d-flex align-items-center justify-content-center mt-auto"
                  onClick={() => handleWhatsAppClick(test.name)}
                  style={{
                    backgroundColor: '#25D366',
                    borderColor: '#25D366',
                    borderRadius: '10px',
                    fontSize: '0.9rem',
                    fontWeight: 600,
                    transition: 'all 0.3s ease'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#128C7E';
                    e.currentTarget.style.borderColor = '#128C7E';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#25D366';
                    e.currentTarget.style.borderColor = '#25D366';
                  }}
                >
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="white" style={{ marginRight: '6px' }}>
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                  </svg>
                  Book via WhatsApp
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="d-flex justify-content-center gap-3">
          <button
            className="btn btn-primary d-flex align-items-center px-5 py-3"
            onClick={() => scroll('left')}
            style={{ borderRadius: '12px', fontWeight: 600, fontSize: '1rem' }}
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ marginRight: '8px' }}>
              <path d="M15 18L9 12L15 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Previous
          </button>
          <button
            className="btn btn-primary d-flex align-items-center px-5 py-3"
            onClick={() => scroll('right')}
            style={{ borderRadius: '12px', fontWeight: 600, fontSize: '1rem' }}
          >
            Next
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ marginLeft: '8px' }}>
              <path d="M9 18L15 12L9 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        </div>
      </div>
      <div className="container my-5">
        <h1 className="text-center mb-5 fw-bold" style={{ letterSpacing: "3px", color: "#00060dff" }}>
          Our Laboratory Features
        </h1>

        <div className="row g-4">
          {[
            {
              icon: "bi bi-wrench",
              title: "Advanced Equipment",
              desc: "State-of-the-art instruments guarantee precise and reliable scientific results."
            },
            {
              icon: "bi-person-check",
              title: "Expert Staff",
              desc: "Highly trained scientists and technicians dedicated to quality and accuracy."
            },
            {
              icon: "bi-shield-check",
              title: "Quality Assurance",
              desc: "Strict protocols ensure compliance with international standards and certifications."
            },
            {
              icon: "bi-clock-history",
              title: "Timely Reporting",
              desc: "Fast turnaround times help clients make critical decisions without delay."
            },
            {
              icon: "bi-people",
              title: "Collaborative Approach",
              desc: "We partner closely with clients to deliver tailored, innovative solutions."
            },
            {
              icon: "bi-graph-up-arrow",
              title: "Innovative Research",
              desc: "Dedicated to advancing science through continuous improvement and breakthroughs."
            },
          ].map(({ icon, title, desc }, idx) => (
            <div key={idx} className="col-md-4">
              <div
                className="h-100 p-4 border rounded shadow-sm text-center transition"
                style={{ cursor: "default", transition: "transform 0.3s ease" }}
                onMouseEnter={e => (e.currentTarget.style.transform = "translateY(-8px)")}
                onMouseLeave={e => (e.currentTarget.style.transform = "translateY(0)")}
              >
                <div className="mb-3 text-primary" style={{ fontSize: "3rem" }}>
                  <i className={`bi ${icon}`}></i>
                </div>
                <h5 className="mb-3 fw-semibold">{title}</h5>
                <p className="text-muted">{desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showModal && renderModal()}
    </div>
  );
};

export default TestCards;